import { ComponentIds } from '@inter-ikea-core/core';
import { DistanceMeasurementComponent, OuterMeasurementsComponent, PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
/**
 * Adds OuterMeasurementsComponent, DistanceMeasurementComponent to table if it's placed agains the wall and removes same components
 * if it is placed on the floor.
 */
export class TableMeasurementsSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'TableMeasurementsSystem', ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
    }
    onAdd(entity, newComponent) {
        const table = this.coreApi.entities.isOneOfProductTypes(entity, [
            ProductType.BROR_TROLLEY,
            ProductType.BROR_WORK_BENCH
        ]);
        if (table && newComponent.snap.hostConnector.key === 'floor') {
            if (entity.hasComponent(OuterMeasurementsComponent.id)) {
                entity.removeComponent(OuterMeasurementsComponent.id);
            }
            if (entity.hasComponent(DistanceMeasurementComponent.id)) {
                entity.removeComponent(DistanceMeasurementComponent.id);
            }
        }
        else if (table && newComponent.snap.hostConnector.key !== 'floor') {
            if (!entity.hasComponent(OuterMeasurementsComponent.id)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (!entity.hasComponent(DistanceMeasurementComponent.id)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.LEFT, Direction.RIGHT]));
            }
        }
    }
    onUpdate() { }
    onRemove() { }
}
//# sourceMappingURL=TableMeasurementsSystem.js.map